/**
 * Permission constants enum
 * Contains all available permissions in the system
 */
export enum PERMISSIONS {
  // Activity Log
  ACTIVITY_LOG_VIEW = "activity_log.view",

  // Address Book
  ADDRESS_BOOK_VIEW = "address_book.view",
  ADDRESS_BOOK_ADD = "address_book.add",
  ADDRESS_BOOK_EDIT = "address_book.edit",
  ADDRESS_BOOK_DELETE = "address_book.delete",

  // Category
  CATEGORY_VIEW = "category.view",
  CATEGORY_ADD = "category.add",
  CATEGORY_VIEW_BY_USER = "category.view_by_user",
  CATEGORY_VIEW_MY_PROJECT = "category.view_my_project",
  CATEGORY_VIEW_PROJECT_SHARE_WITH_ME = "category.view_project_share_with_me",
  CATEGORY_VIEW_PROJECT_FAVORITE = "category.view_project_favorite",

  // Dashboard
  DASHBOARD_VIEW = "dashboard.view",

  // Project
  PROJECT_FULL_ACCESS = "project.full_access",
  PROJECT_VIEW = "project.view",
  PROJECT_ADD = "project.add",
  PROJECT_EDIT = "project.edit",
  PROJECT_DELETE = "project.delete",
  PROJECT_ARCHIVE = "project.archive",
  PROJECT_FAVORITE = "project.favorite",

  // Project Build
  PROJECT_BUILD_VIEW = "project.build.view",
  PROJECT_BUILD_ADD = "project.build.add",
  PROJECT_BUILD_EDIT = "project.build.edit",
  PROJECT_BUILD_DELETE = "project.build.delete",
  PROJECT_BUILD_DOWNLOAD = "project.build.download",
  PROJECT_BUILD_DUPLICATE = "project.build.duplicate",
  PROJECT_BUILD_ARCHIVE = "project.build.archive",
  PROJECT_BUILD_ADD_INVITEE = "project.build.add_invitee",
  PROJECT_BUILD_EDIT_INVITEE = "project.build.edit_invitee",
  PROJECT_BUILD_VIEW_INVITEE = "project.build.view_invitee",
  PROJECT_BUILD_DEACTIVATE_INVITEE = "project.build.deactivate_invitee",
  PROJECT_BUILD_SEND_INVITEE = "project.build.send_invitee",
  PROJECT_BUILD_ADD_COMPONENT = "project.build.add_component",
  PROJECT_BUILD_ADD_COMPONENT_IN_INVITEE = "project.build.add_component_in_invitee",
  PROJECT_BUILD_DELETE_COMPONENT_IN_INVITEE = "project.build.delete_component_in_invitee",
  PROJECT_BUILD_RESTORE_COMPONENT = "project.build.restore_component",
  PROJECT_BUILD_UNLIST_COMPONENT = "project.build.unlist_component",
  PROJECT_BUILD_CHANGE_STATUS = "project.build.change_status",
  PROJECT_BUILD_TO_IN_PRODUCTION = "project.build.to_in_production",
  PROJECT_BUILD_GET_STATUS = "project.build.get_status",
  PROJECT_BUILD_VIEW_ADDITIONAL_INFO = "project.build.view_additional_info",
  PROJECT_BUILD_CREATE_ADDITIONAL_INFO = "project.build.create_additional_info",

  // Project Component
  PROJECT_COMPONENT_VIEW = "project.component.view",
  PROJECT_COMPONENT_ADD = "project.component.add",
  PROJECT_COMPONENT_EDIT = "project.component.edit",
  PROJECT_COMPONENT_DELETE = "project.component.delete",
  PROJECT_COMPONENT_DUPLICATE = "project.component.duplicate",
  PROJECT_COMPONENT_ARCHIVE = "project.component.archive",
  PROJECT_COMPONENT_VIEW_TYPE = "project.component.view_type",
  PROJECT_COMPONENT_VIEW_FOLDER = "project.component.view_folder",
  PROJECT_COMPONENT_ADD_FOLDER = "project.component.add_folder",
  PROJECT_COMPONENT_EDIT_FOLDER = "project.component.edit_folder",
  PROJECT_COMPONENT_DELETE_FOLDER = "project.component.delete_folder",
  PROJECT_COMPONENT_MOVE_TO_FOLDER = "project.component.move_to_folder",

  // Project Component History
  PROJECT_COMPONENT_HISTORY_VIEW = "project.component.history.view",
  PROJECT_COMPONENT_HISTORY_ADD = "project.component.history.add",
  PROJECT_COMPONENT_HISTORY_DELETE = "project.component.history.delete",
  PROJECT_COMPONENT_HISTORY_DOWNLOAD = "project.component.history.download",
  PROJECT_COMPONENT_HISTORY_COMMIT = "project.component.history.commit",
  PROJECT_COMPONENT_HISTORY_REVERT = "project.component.history.revert",
  PROJECT_COMPONENT_HISTORY_MERGE = "project.component.history.merge",
  PROJECT_COMPONENT_HISTORY_DUPLICATE = "project.component.history.duplicate",

  // Project Component History - BOM
  PROJECT_COMPONENT_HISTORY_BOM_VIEW = "project.component.history.bom.view",
  PROJECT_COMPONENT_HISTORY_BOM_UPLOAD = "project.component.history.bom.upload",
  PROJECT_COMPONENT_HISTORY_BOM_DELETE = "project.component.history.bom.delete",
  PROJECT_COMPONENT_HISTORY_BOM_ADD_COLUMN = "project.component.history.bom.add_column",
  PROJECT_COMPONENT_HISTORY_BOM_DELETE_COLUMN = "project.component.history.bom.delete_column",
  PROJECT_COMPONENT_HISTORY_BOM_ADD_SUPPLIER = "project.component.history.bom.add_supplier",

  // Project Component History - PCB
  PROJECT_COMPONENT_HISTORY_PCB_VIEW_BOM = "project.component.history.pcb.view_bom",
  PROJECT_COMPONENT_HISTORY_PCB_VIEW_SPECIFICATION = "project.component.history.pcb.view_specification",
  PROJECT_COMPONENT_HISTORY_PCB_VIEW_GERBER = "project.component.history.pcb.view_gerber",
  PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_BOM = "project.component.history.pcb.upload_bom",
  PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_STACKUP = "project.component.history.pcb.upload_stackup",
  PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_GERBER = "project.component.history.pcb.upload_gerber",
  PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_ATTACHMENT = "project.component.history.pcb.upload_attachment",
  PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_ASSEMBLY = "project.component.history.pcb.upload_assembly",
  PROJECT_COMPONENT_HISTORY_PCB_DELETE_BOM = "project.component.history.pcb.delete_bom",
  PROJECT_COMPONENT_HISTORY_PCB_DELETE_ATTACHMENT = "project.component.history.pcb.delete_attachment",
  PROJECT_COMPONENT_HISTORY_PCB_DELETE_GERBER = "project.component.history.pcb.delete_gerber",
  PROJECT_COMPONENT_HISTORY_PCB_DELETE_STACKUP = "project.component.history.pcb.delete_stackup",
  PROJECT_COMPONENT_HISTORY_PCB_DELETE_ASSEMBLY = "project.component.history.pcb.delete_assembly",
  PROJECT_COMPONENT_HISTORY_PCB_DELETE_COLUMN_BOM = "project.component.history.pcb.delete_column_bom",
  PROJECT_COMPONENT_HISTORY_PCB_ADD_COLUMN_BOM = "project.component.history.pcb.add_column_bom",
  PROJECT_COMPONENT_HISTORY_PCB_ADD_SUPPLIER_BOM = "project.component.history.pcb.add_supplier_bom",
  PROJECT_COMPONENT_HISTORY_PCB_UPDATE_LAYER_ASSIGNMENT = "project.component.history.pcb.update_layer_assignment",
  PROJECT_COMPONENT_HISTORY_PCB_SORT_LAYER_ASSIGNMENT = "project.component.history.pcb.sort_layer_assignment",
  PROJECT_COMPONENT_HISTORY_PCB_UPDATE_SPECIFICATION = "project.component.history.pcb.update_specification",

  // Project Component History - Mechanical
  PROJECT_COMPONENT_HISTORY_MECHANICAL_VIEW_3D = "project.component.history.mechanical.view_3d",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_VIEW_BOM = "project.component.history.mechanical.view_bom",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_VIEW_ADDITIONAL_INFO = "project.component.history.mechanical.view_additional_info",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_UPLOAD_3D = "project.component.history.mechanical.upload_3d",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_UPLOAD_BOM = "project.component.history.mechanical.upload_bom",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_UPLOAD_ATTACHMENT = "project.component.history.mechanical.upload_attachment",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_DELETE_3D = "project.component.history.mechanical.delete_3d",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_DELETE_BOM = "project.component.history.mechanical.delete_bom",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_DELETE_ATTACHMENT = "project.component.history.mechanical.delete_attachment",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_DELETE_COLUMN_BOM = "project.component.history.mechanical.delete_column_bom",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_ADD_COLUMN_BOM = "project.component.history.mechanical.add_column_bom",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_ADD_SUPPLIER_BOM = "project.component.history.mechanical.add_supplier_bom",
  PROJECT_COMPONENT_HISTORY_MECHANICAL_UPDATE_ADDITIONAL_INFO = "project.component.history.mechanical.update_additional_info",

  // Project Component History - Firmware
  PROJECT_COMPONENT_HISTORY_FIRMWARE_VIEW = "project.component.history.firmware.view",
  PROJECT_COMPONENT_HISTORY_FIRMWARE_UPLOAD_ATTACHMENT = "project.component.history.firmware.upload_attachment",
  PROJECT_COMPONENT_HISTORY_FIRMWARE_DELETE_ATTACHMENT = "project.component.history.firmware.delete_attachment",
  PROJECT_COMPONENT_HISTORY_FIRMWARE_UPDATE_ADDITIONAL_INFO = "project.component.history.firmware.update_additional_info",

  // Project Conversation
  PROJECT_CONVERSATION_VIEW = "project.conversation.view",
  PROJECT_CONVERSATION_ARCHIVE = "project.conversation.archive",
  PROJECT_CONVERSATION_FAVORITE = "project.conversation.favorite",
  PROJECT_CONVERSATION_DOWNLOAD = "project.conversation.download",
  PROJECT_CONVERSATION_SEND_MESSAGE = "project.conversation.send_message",
  PROJECT_CONVERSATION_VIEW_NOTE = "project.conversation.view_note",
  PROJECT_CONVERSATION_UPDATE_NOTE = "project.conversation.update_note",
  PROJECT_CONVERSATION_VIEW_STATUS = "project.conversation.view_status",
  PROJECT_CONVERSATION_ADD_STATUS = "project.conversation.add_status",
  PROJECT_CONVERSATION_DELETE_STATUS = "project.conversation.delete_status",
  PROJECT_CONVERSATION_SELECT_STATUS = "project.conversation.select_status",

  // User
  USER_VIEW = "user.view",
  USER_ADD = "user.add",
  USER_ARCHIVE = "user.archive",
  USER_CHANGE_ROLE = "user.change_role",
  USER_SHARE_PROJECT = "user.share_project",

  SYNC_COMMIT_COMPONENT_VIEW = "sync_commit_component.view",
  SYNC_COMMIT_COMPONENT_ADD = "sync_commit_component.add",
  SYNC_COMMIT_COMPONENT_EDIT = "sync_commit_component.edit",
  SYNC_COMMIT_COMPONENT_DELETE = "sync_commit_component.delete",

  // Group
  GROUP_ORGANIZATION_VIEW = "group_organization.view",
  GROUP_ORGANIZATION_ADD = "group_organization.add",
  GROUP_ORGANIZATION_EDIT = "group_organization.edit",
  GROUP_ORGANIZATION_DELETE = "group_organization.delete",
  GROUP_ORGANIZATION_MOVE_PROJECT = "group_organization.move_project",
  GROUP_ORGANIZATION_REMOVE_PROJECT = "group_organization.remove_project",
  GROUP_ORGANIZATION_ADD_MEMBER = "group_organization.add_member",
  GROUP_ORGANIZATION_REMOVE_MEMBER = "group_organization.remove_member",
}
